document.addEventListener('click', function(e) {
  const btn = e.target.closest('.open_choose_option');
  if (!btn) return;

  e.preventDefault();

  const amazonUrl = btn.dataset.amazonUrl || '#';
  const chewyUrl = btn.dataset.chewyUrl || '#';
  if (amazonUrl === '#' && chewyUrl === '#') return;

  const modal = document.getElementById('marketplace-modal');
  modal.querySelector('.option-card.amazon').href = amazonUrl;
  modal.querySelector('.option-card.chewy').href = chewyUrl;
  modal.style.display = 'flex';
  modal.focus();
});

document.addEventListener('click', function(e) {
  if (e.target.closest('.modal-close_marketplace')) {
    document.getElementById('marketplace-modal').style.display = 'none';
  }
});

document.addEventListener('click', function(e) {
  const modal = document.getElementById('marketplace-modal');
  if (e.target === modal) modal.style.display = 'none';
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.getElementById('marketplace-modal').style.display = 'none';
  }
});
